import { Component } from 'react'

import * as h from 'h'

import Labels from 'components/Labels'
import Raw from 'components/Raw'
import BackLink from './BackLink'
import LightboxImage from 'components/Popout/LightboxImage'
import UiStore from 'stores/UiStore'

import styles from './styles.scss'

export default class StandardContent extends Component {
  render () {
    const { image, vanillaImage, title, labels,
      right, preContent, content, postContent, theme } = this.props

    return h.article(h.ca(styles.articleContainer),
      (image && vanillaImage) ? (
        h.img({ src: image, ...h.ca(styles.standardVanillaImage), name: '' })
      ) : (
        h.div(h.ca(styles.standardImageBox),
          h.h(LightboxImage, { image: image }),
          h.div(h.ca(styles.standardImageBoxInner),
            h.button({
              ...h.ca(styles.imageButton),
              type: 'button',
              onClick: () => { UiStore.lightboxIsVisible = true }
            },
              'See full image'),
            h.h(BackLink),
            h.h2(h.ca(styles.standardTitle), title)),
          h.div(h.ca(styles.standardImageBoxOverlay)))),
      h.div(h.ca(styles.standardTextBody),
        h.div(h.ca(styles.standardMeta),
          labels && h.div(null,
            h.h(Labels, { labels })),
          right && h.div(h.ca(styles.standardMetaRight), right)),
        preContent,
        h.div(h.ca(styles.standardContentContent, theme && theme.content),
          h.h(Raw, { content })),
        postContent)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/StandardContent.js